export const monacoEditorFontSizes = {
    default:  14,
    minimum: 10,
    maximum: 40
};

export enum customLanguages {
    FLOW_VARIABLE_SYNTAX = 'flowVariablesSyntax'
}

export const monacoLanguages: any[] = [
  {
    contentTypes: ['application/json'],
    language: 'json'
  },
  {
    contentTypes: ['application/xml', 'text/xml'],
    language: 'xml'
  },
  {
    contentTypes: ['text/plain'],
    language: 'text/plain'
  }
];

/**
 * Enables language support for flow variables syntax
 */
export function registerFlowVariablesLanguage() {
    monaco.languages.register({ id: customLanguages.FLOW_VARIABLE_SYNTAX });
    monaco.languages.setMonarchTokensProvider(customLanguages.FLOW_VARIABLE_SYNTAX, {
        tokenizer: {
            root: [
                [/\[\[.*]]/, 'flowVariable']
            ]
        }
    });
}

/**
 * Creates a theme for variables syntax
 */
export function defineBlueVariablesTheme() {
    monaco.editor.defineTheme('clickatellBlueVariablesTheme', {
        base: 'vs',
        inherit: false,
        rules: [
            { token: 'flowVariable', foreground: clickatellBlue400 },
        ],
        colors: editorColors
    });
}

export function defineDefaultBlueTheme() {
    monaco.editor.defineTheme('clickatell-blue', {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'string.key.json', foreground: clickatellBlue400 },
            { token: 'string.value.json', foreground: honey500 },
            { token: 'number.json', foreground: honey500 },
            { token: 'keyword.json', foreground: honey500 },
            { token: 'delimiter.bracket.json', foreground: clickatellBlue400 },
            { token: 'delimiter.array.json', foreground: clickatellBlue400 },
            { token: 'delimiter.colon.json', foreground: clickatellBlue400 },
            { token: 'delimiter.comma.json', foreground: clickatellBlue400 },
            { token: 'delimiter.xml', foreground: clickatellBlue400 },
            { token: 'metatag.xml', foreground: clickatellBlue400 },
            { token: 'attribute.name.xml', foreground: clickatellBlue400 },
            { token: 'attribute.value.xml', foreground: honey500 },
            { token: 'tag.xml', foreground: clickatellBlue400 },
        ],
       colors: editorColors
    });
}

const clickatellDarkBlue500 = '#233659';
const honey500 = '#f8bd32';
const clickatellBlue400 = '#6bd5f1';
const editorColors = {
    'editor.foreground': honey500,
    'editor.background': clickatellDarkBlue500,
    'editor.lineHighlightBackground': clickatellDarkBlue500,            //  focused line color
    'editorIndentGuide.background': clickatellDarkBlue500,              //  focused line color
};

export function sanitizeContentType(contentType: string): string {
  const languageSet = monacoLanguages.find(supportedLanguageSet => {
    const contentTypes: [] = supportedLanguageSet['contentTypes'];
    return contentTypes.find(supportedContentType => {
        if (contentType) {
            return contentType.includes(supportedContentType);
        }
    });
  });

  return languageSet ? languageSet['language'] : contentType;
}
